import path from 'path';

export function toPosixRelative(root: string, target: string): string {
  const rel = path.relative(root, target);
  if (!rel || rel === '') return '';
  return rel.split(path.sep).join('/');
}

export function resolveDisplayPath(target: string): string {
  return path.resolve(target);
}

export function isInsideRoot(root: string, target: string): boolean {
  const rel = path.relative(root, target);
  return rel === '' || (!rel.startsWith('..') && !path.isAbsolute(rel));
}
